module.exports = __webpack_public_path__ + "static/media/bg-iphone-mobile-2.fb48d44d.png";